import React from "react";
import PressDetailPresenter from "./PressDetailPresenter";
import { useParams, useNavigate } from "react-router-dom";
import { useScrollTop } from '../../hooks';
import { press } from '../../api';

// TODO: REMOVE
import pressDetailImage from '../../images/press/press_detail.png';

const pressDetailInitState = {
  // title: '박성웅·연우·김지영·이수경, KBS 새 드라마 ‘개소리’ 출연 타이틀 타이틀 타이틀 타이틀 길면 최대 2줄까지 노출',
  title: '박성웅·연우·김지영·이수경, KBS 새 드라마 ‘개소리’ 출연 타이틀 타이틀 타이틀 타이틀 길면 최대 2줄까지 노출 박성웅·연우·김지영·이수경, KBS 새 드라마 ‘개소리’ 출연 타이틀 타이틀 타이틀 타이틀 길면 최대 2줄까지 노출 박성웅·연우·김지영·이수경, KBS 새 드라마 ‘개소리’ 출연 타이틀 타이틀 타이틀 타이틀 길면 최대 2줄까지 노출',
  // image: '',
  image: pressDetailImage,
  date: '2024.08.08.',
  content: `배우 박성웅과 연우, 김지영, 이수경이 KBS2 새 수목드라마 '개소리'에 출연한다.

오는 9월 첫 방송 예정인 '개소리'(극본 변숙경, 연출 김유진)는 활약 만점 시니어들과 경찰견 출신 '소피'가 그리는 유쾌하고 발칙한 노년 성장기를 담은 시츄에이션 코미디 드라마다.

박성웅은 극 중 국민 배우 순재(이순재)의 늦둥이 외아들 이기동 역을 맡았다. 순하고 착한 성품의 소유자인 기동은 말 못할 사정 때문에 거제도에 정착해 지내며 아버지 순재를 피해 다닌다. 박성웅은 평소 깊이감 있는 카리스마부터 코미디까지 폭넓은 스펙트럼의 캐릭터를 소화해 왔기에, 이번 '개소리' 출연을 통해 어떤 코믹 연기를 보여줄지 주목된다.

거제도의 치안을 책임지는 순경 '홍초원' 역은 배우 연우가 맡았다. 초원은 따뜻한 마음과 다정한 성격, 정의로운 면모를 지닌 인물로 거제도에서 벌어지는 여러 사건에 직접 뛰어들어 진실을 파헤쳐 나간다.`
};

const PressDetailContainer = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [pressDetail, setPressDetail] = React.useState(pressDetailInitState);

  const getPressDetail = async () => {
    try {
      const response = await press.getPressDetail(id);
      setPressDetail(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleBack = () => navigate(-1);
  
  React.useEffect(() => {
    // getPressDetail();
  }, []);

  useScrollTop();

  return (
    <PressDetailPresenter 
      pressDetail={pressDetail} 
      handleBack={handleBack} 
    />
  );
};

export default PressDetailContainer;
